module.exports = __webpack_public_path__ + "static/media/flowchart_construction_collage_dark.bae552fc.jpg";